import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Check } from '../../assets/images/svg/check-1.svg';
import themeColors from '../../assets/styles/themeColors';

const CheckIconStyled = styled(Check)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorTextXLLight};
  ${({ isDone }) => isDone && `fill: ${themeColors.colorCheckedIcon};`}
`;

const CheckIcon = (props) => <CheckIconStyled {...props} />;

CheckIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CheckIcon.defaultProps = {
  w: '20px',
  h: '20px',
};

export default CheckIcon;
